import styled, { css } from "styled-components";

export const ReactionIcon = styled.div<{ reactionName: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: 1.45rem;
    width: 1.45rem;
    padding: 0.4rem;
    box-sizing: content-box;
  }

  svg,
  ::before {
    transition: all 300ms;
  }

  :hover {
    svg {
      scale: 1.3;
      transform: translateY(-7px);
    }
    ::before {
      opacity: 1;
    }
  }

  ::before {
    content: "${({ reactionName }) => reactionName}";
    color: var(--posted-at-text-color);

    padding: 0.01rem 0.3rem;
    border-radius: 4px;
    font: 400 0.75rem/1.125rem "Inter";
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: -30px;
  }
`;

export const ReactionsModalContainer = styled.div<{
  show: boolean;
}>`
  border-radius: 4px;
  display: flex;
  align-items: center;
  position: absolute;
  justify-content: center;
  left: 0;
  top: -3rem;

  pointer-events: none;
  opacity: 0;
  transition: 0.3s all;

  &,
  ${ReactionIcon}::before {
    background-color: ${({ theme }) => theme.groups.borderColorComponentsMural};
    border: 1px solid ${({ theme }) => theme.groups.borderColorComponentsMural};
  }

  ${({ show }) =>
    show &&
    css`
      pointer-events: all;
      opacity: 1;
    `}
`;
